import moment from 'moment';

Vue.component('sales-pipeline', {
    props: ['pipeline-data', 'from', 'to'],

    data () {
        return {
            individualDays: []
        };
    },

    mounted () {
        this.render();
    },

    methods: {
        render () {
            let from = moment(this.from, 'DD-MM-YYYY');
            let to = moment(this.to, 'DD-MM-YYYY');
            let daysInPeriod = Math.abs(to.diff(from, 'days')) + 1;
            this.individualDays = [];

            // Calculate the individual days in the period
            for (let day = 0; day < daysInPeriod; day++) {
                let date = moment(from.format('YYYY-MM-DD'), 'YYYY-MM-DD').add(day, 'd');

                this.individualDays.push(date.format('YYYY-MM-DD'));
            }

            // Trigger popovers after renders
            Vue.nextTick(() => {
                $('.popover-trggr').popover({
                    trigger: 'click',
                    html: true
                });
            });

            $('body').on('click', '.popover-trggr', function () {
                $('.popover-trggr').not(this).popover('hide');
            });
        },

        arrayUnique(array) {
            let a = array.concat();

            for (var i = 0; i < a.length; ++i) {
                for (var j = i + 1; j < a.length; ++j) {
                    if(a[i] === a[j]) {
                        a.splice(j--, 1);
                    }
                }
            }

            return a;
        },

        generatePopover (sale) {
            let html = '';

            // Lead ID
            html += '<strong>Quote ID: </strong> <a href="/admin/quotes/edit/' + sale.quote_id + '">#' + sale.quote_id + '</a><br>';

            // Sales Amount
            if (sale.value !== undefined) {
                html += '<strong>Value: </strong> £' + sale.value.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + '<br>';
            }

            if (sale.company != undefined) {
                // Company Name
                html += '<strong>Company: </strong> ' + sale.company + '<br>';
            }

            if (sale.subject != undefined) {
                // Subject
                html += '<strong>Subject: </strong> ' + sale.subject + '<br>';
            }

            if (sale.type != undefined) {
                // Subject
                html += '<strong>Type: </strong> ' + sale.type + '<br>';
            }

            // Date
            html += '<strong>Date: </strong> ' + moment(sale.date).format('DD/MM/YY');

            if (sale.subject != undefined) {
                // Time
                html += '<br><strong>Time: </strong> ' + sale.time;
            }

            return html;
        }
    },

    filters: {
        displayDate (date) {
            return moment(date).format("DD/MM");
        }
    },

    watch: {
        pipelineData () {
            this.render();
        }
    },

    template: `
        <div class="pipeline">
            <div class="rail"></div>
           
            <div class="days-container">
                <div class="day" v-for="day in individualDays">
                    <div class="prospect-container">
                        <div class="popover-trggr prospect" v-for="p in pipelineData.prospect[day]" data-toggle="popover" :data-content="generatePopover(p)"></div>
                    </div>
                    
                    <div class="sales-container">
                        <div class="popover-trggr" :class="s.status" v-for="s in pipelineData.rail[day]" data-toggle="popover" :data-content="generatePopover(s)"></div>
                    </div>
                    
                    <div class="dead-container">
                        <div class="popover-trggr dead" v-for="d in pipelineData.meetings[day]" data-toggle="popover" :data-content="generatePopover(d)"></div>
                    </div>
                    
                    <div class="date">
                        {{ day | displayDate }}
                    </div>
                </div>
            </div>
        </div>
    `
});
